import React, { useState, useEffect, useContext } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
import MeetingForm from 'components/brandActivation/meetingForm/meetingForm';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import Regex from 'services/utils/regex/Regex';
import parse from 'html-react-parser';
import ErrModalPop from 'components/sales/modal/errorModal';

const ScheduleAMeeting = ({
  pocList,
  getPocList,
  createMeeting,
  updateMeeting,
  match,
  history,
  meetingById = null,
  getMeetingById,
  getCorpClientList,
  corpClientList,
  getCorpPocList,
  corpClientPoc,
}) => {
  const { id } = useParams();
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setSiteId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [teamId, setTeamId] = useState();
  const inputs = {
    meetingDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [meetingData, setCorporateData] = useState(inputs);
  const [viewMeeting, setViewMeeting] = useState({});
  const [errorMsg, setIsErrorMsg] = useState('');
  const [isErrorModal, setIsErrorModal] = useState(false);

  const handleForm = (val) => {
    setCorporateData({ ...meetingData, meetingDetails: val });
  };
  const handleSubmit = () => {
    const { meetingDetails } = meetingData;
    console.log(meetingDetails);
    if (
      meetingDetails.subject !== '' &&
      meetingDetails.body !== ''
    ) {
      setIsFiled(false);
      (async () => {
        setIsLoading(true);
        const res = await (id
          ? updateMeeting(meetingDetails)
          : createMeeting(meetingDetails));
        setIsLoading(false);
        if (res) {
          setIsModal(true);
          
        }
      })();
    }else{
      var errMsg = '';
      if(meetingDetails.client === ''){
        errMsg = errMsg+'Client name Is Required!<br/>';  
      }
      if(meetingDetails.subject === ''){
        errMsg = errMsg+'Subject Is Required! <br/>';  
      }
      if(meetingDetails.body === ''){
        errMsg = errMsg+'Summary Is Required! <br/>';  
      }
      
      setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        setIsFiled(true);
       setIsModal(false);
       return false;
    }
    // if (meetingDetails === null) {
    //   setIsFiled(true);
    //   setIsModal(false);
    //   return false;
    // } else {
    //   setIsFiled(false);
    //   (async () => {
    //     setIsLoading(true);
        // const res = await (id
        //   ? updateMeeting(meetingDetails)
        //   : createMeeting(meetingDetails));
    //     setIsLoading(false);
    //     if (res) {
    //       setIsModal(true);
    //     }
    //   })();
    // }
  };

  useEffect(() => {
    if (getCorpClientList !== null)
      (async () => {
        setIsLoading(true);
        await getCorpClientList(match.params.siteId);
        setIsLoading(false);
      })();
  }, [getCorpClientList, match.params.siteId]);

  useEffect(() => {
    (async () => {
      const data = await localStorage.getItem('viewDetail');
      if (data.length && data !== 'undefined') {
        const team =
          data.length && JSON.parse(data) ? JSON.parse(data)[0].lead_type : '';
        setTeamId(team);
      }
    })();
  }, []);

  useEffect(() => {
    setSiteId(match.params.siteId);
    if (siteId) {
      (async () => {
        setIsLoading(true);
        await getPocList(siteId, match.params.id);
        setIsLoading(false);
      })();
    }
  }, [siteId, getPocList, setIsLoading, match.params.id]);

  useEffect(() => {
    (async () => {
      if (id) {
        setIsLoading(true);
        let viewData = await getMeetingById(id);
        if (viewData) setViewMeeting({ ...viewData });
        setIsLoading(false);
      }
    })();
  }, [getMeetingById, id]);

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/brand-activation/scheduled-meetings/${siteId}`);
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.scheduleMeeting}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };
  const handleModalHide1 = () => setIsErrorModal(false);
  return (
    <Layout
      title={localization.scheduleMeeting}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/scheduled-meetings/${match.params.siteId}`}
    >
      <MeetingForm
        pocList={pocList}
        handleValue={handleForm}
        siteId={siteId}
        meetingById={id ? meetingById : null}
        teamId={teamId}
        corpClientList={corpClientList}
        getCorpPocList={getCorpPocList}
        corpClientPoc={corpClientPoc}
        viewMeeting={viewMeeting}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingSuccess}</h5>
          <Button onClick={handleModalHide} className="btn btn-primary mb-4">
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">
          {parse(errorMsg)}
        </div>
      </ErrModalPop>
    </Layout>
  );
};

ScheduleAMeeting.propTypes = {};

export default ScheduleAMeeting;
